/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePackagingTypeDto } from '../../models/create-packaging-type-dto';
import { PackagingType } from '../../models/packaging-type';

export interface PackagingControllerCreate$Params {
      body: CreatePackagingTypeDto
}

export function packagingControllerCreate(http: HttpClient, rootUrl: string, params: PackagingControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PackagingType>> {
  const rb = new RequestBuilder(rootUrl, packagingControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PackagingType>;
    })
  );
}

packagingControllerCreate.PATH = '/packaging-types';
